import React, { Component } from 'react'

import numeral from 'numeral'
import * as moment from 'moment'

class InfoComponent extends Component {
  render() {
    return (
      <ul className="list-unstyled text-small">
        {this.props.versionStatus === 200 && (
          <li className="text-muted text-small">
            Version: {this.props.versionData}
          </li>
        )}
        {this.props.corpusStatus === 200 && (
          <li className="text-muted text-small">
            {numeral(this.props.corpusData.numberOfDocuments).format('0,0')}{' '}
            documents indexed
          </li>
        )}
        {/* do not display last Update if it is not (yet) indexed for this corpus */}
        {this.props.corpusData.lastUpdate !== 'unknown' && (
          <li className="text-muted text-small">
            Last update:{' '}
            {moment(this.props.corpusData.lastUpdate).format(
              'D MMM YYYY HH:MM'
            )}
          </li>
        )}
      </ul>
    )
  }
}

export default InfoComponent
